import React from "react";
import {
  ActivityIndicator,
  StyleSheet,
  Text,
  TouchableOpacity,
} from "react-native";
import { Feather } from "@expo/vector-icons";

type ClearCacheButtonProps = {
  onPress: () => void;
  isClearing: boolean;
};

function ClearCacheButton({
  onPress,
  isClearing,
}: ClearCacheButtonProps): React.JSX.Element {
  return (
    <TouchableOpacity
      style={styles.button}
      onPress={onPress}
      disabled={isClearing}
    >
      {isClearing ? (
        <ActivityIndicator color="#fff" size="small" />
      ) : (
        <>
          <Feather name="trash-2" size={18} color="#fff" style={styles.icon} />
          <Text style={styles.buttonText}>Clear Cache</Text>
        </>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: "#4299E1",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 12,
    borderRadius: 8,
  },
  icon: {
    marginRight: 8,
  },
  buttonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "600",
  },
});

export default ClearCacheButton;
